goog.provide("shadow.js.shim.module$date_fns$parseISO$default");
shadow.js.shim.module$date_fns$parseISO$default = shadow.js.require(140, {})["default"];
